import getLatLng from "@components/GoogleMap/_lib/getLatLng";

const getMarkerListBounds = (data) => {
  const bounds = new window.google.maps.LatLngBounds();

  data.forEach((item) => {
    const { lat, lng } = getLatLng(item);

    if (!isNaN(lat) && !isNaN(lng)) {
      bounds.extend({ lat, lng });
    }
  });

  return bounds;
};

export default getMarkerListBounds;
